interface IEngineConfig {
  GaussianSplats3D: string;
  Spark: string;
}
export const EngineConfig: IEngineConfig = {
  GaussianSplats3D: 'GaussianSplats3D',
  Spark: 'Spark',
};
